import { chart } from '../en';

export const chartAR: typeof chart = {
  chartWithoutData: 'عذرا، لا توجد بيانات متاحة.',
  nationalAverage: 'المتوسط الشهري لدولة الإمارات العربية المتحدة',
};
